import { defineStore } from "pinia";

export const usePromoCodeStore = defineStore("promoCode", {
    state: () => ({
        promoCode: "",
        discountType: null,
        discountData: 0,
        promocodeStatusText: "",
        promocodeStatusColor: "",
    }),

    getters: {
        getPromoCode: (state) => state.promoCode,
        getDiscountType: (state) => state.discountType,
        getDiscountData: (state) => state.discountData,
        getPromocodeStatusText: (state) => state.promocodeStatusText,
        getPromocodeStatusColor: (state) => state.promocodeStatusColor,
    },

    actions: {
        setPromoCode(code) {
            this.promoCode = code;
        },

        async checkPromoCode(cartStore) {
            if (!this.promoCode) {
                this.discountType = null;
                this.discountData = 0;
                return;
            }

            try {
                const config = useRuntimeConfig();
                const response = await $fetch(`${config.public.apiUrl}promocode`, {
                    method: "POST",
                    body: {
                        code: this.promoCode,
                        cartAmount: cartStore.totalPriceWithoutDiscount,
                        productPackageIds: cartStore.productPackageIds,
                        productIds: cartStore.productIds,
                    },
                });

                if (response.error) {
                    this.promocodeStatusText = response.error;
                    this.promocodeStatusColor = "red";
                    this.discountType = null;
                    this.discountData = 0;
                } else {
                    this.promocodeStatusText = response.message;
                    this.promocodeStatusColor = "green";
                    this.discountType = response.type;
                    this.discountData = response.data;
                }
            } catch (error) {
                console.error(error);
                this.promocodeStatusText = "Промокод не дійсний";
                this.promocodeStatusColor = "red";
                this.discountType = null;
                this.discountData = 0;
            }
        },
    },
});
